import { useCallback } from 'react';

import Button, { ButtonProps } from '@mui/material/Button';

import { Icon } from '../icon';

interface ExpandAllButtonProps {
  expanded: boolean;
  toggle: (e: boolean) => void;
  sx?: ButtonProps['sx'];
}

export const ExpandAllButton = ({
  expanded,
  toggle,
  sx,
}: ExpandAllButtonProps) => {
  const handleClick = useCallback(() => {
    toggle(!expanded);
  }, [expanded, toggle]);
  return (
    <Button
      sx={sx}
      endIcon={
        expanded ? (
          <Icon name={'UnfoldLessRounded'} />
        ) : (
          <Icon name={'Expand'} />
        )
      }
      size="small"
      variant={expanded ? 'contained' : 'text'}
      onClick={handleClick}
    >
      {expanded ? 'Collapse' : 'Expand All'}
    </Button>
  );
};

export default ExpandAllButton;
